
import IconNoteEye from "@/components/v2/icons/IconNoteEye.vue";
import IconNoteFemale from "@/components/v2/icons/IconNoteFemale.vue";
import IconNoteMale from "@/components/v2/icons/IconNoteMale.vue";
import IconNoteTransgender from "@/components/v2/icons/IconNoteTransgender.vue";
import IconSolidVideoCam from "@/components/v2/icons/IconSolidVideoCam.vue";
import IconImg from "~/components/v2/icons/IconImg.vue";
import IconMarker from "~/components/v2/icons/IconMarker.vue";
import IconQuastion from "~/components/v2/icons/IconQuastion.vue";

import { mdiTrashCan, mdiChevronRight } from "@mdi/js";
import GalleryPhoto from "@/components/ui/GalleryPhoto.vue";

export default {
  components: {
    GalleryPhoto,
    IconNoteFemale,
    IconNoteMale,
    IconNoteTransgender,
    IconImg,
    IconMarker,

    IconNoteEye,
    IconSolidVideoCam,
    IconQuastion,
  },

  props: {
    newsItem: {
      type: Object,
      required: true,
    },
    showPohileHistoryLink: {
      type: Boolean,
      default: true,
    },
    foldable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      mdiTrashCan,
      mdiChevronRight,
      isFolded: true,

      newProfileAboutFolded: true,

      isOldAboutMeFolded: true,
      isNewAboutMeFolded: true,
    };
  },

  computed: {
    name() {
      return this.newsItem.profile.name;
    },

    deletedPhotos() {
      return this.newsItem.deleted_photos;
    },

    photos() {
      return this.newsItem.photos;
    },

    prohileHistoryLink() {
      return `/escorts-updates/${this.newsItem.profile.slug}`;
    },

    newsType() {
      return this.newsItem.additional_type || this.newsItem.type_id;
    },

    gender() {
      return this.newsItem.profile.gender;
    },

    genderIcon() {
      switch (this.gender) {
        case "female":
          return IconNoteFemale;
        case "male":
          return IconNoteMale;
        case "transgender":
          return IconNoteTransgender;
        default:
          return null;
      }
    },

    icon() {
      // new, photos, reviews, tours, description, video
      switch (this.newsType) {
        case "new":
          return this.genderIcon;
        case "video":
          return IconSolidVideoCam;
        case "tours":
          return IconMarker;
        case "photos":
          return IconImg;
        case "reviews":
          return IconNoteEye;
        case "description":
          return this.genderIcon;
        case "answer":
          return IconQuastion;
        default:
          return null;
      }
    },

    nameLink() {
      return `<a href="/profile/${this.newsItem.profile.slug}" target="_blank">${this.name}</a>`;
    },

    title() {
      // new, photos, reviews, tours, description, video
      switch (this.newsType) {
        case "new":
          return `The new profile <span class="update-content__title--pc">of ${this.nameLink}</span> was added`;
        case "video":
          return `<span class="update-content__title--pc">${this.nameLink} </span>added a new video`;
        case "tours":
          return `<span class="update-content__title--pc">${this.nameLink} </span>set new tour`;
        case "photos":
          return `<span class="update-content__title--pc">${this.nameLink} </span>added new photos`;
        case "reviews":
          return `New review <span class="update-content__title--pc">for ${this.nameLink}</span> was added`;
        case "description":
          return `The profile <span class="update-content__title--pc">of ${this.nameLink}</span> has been changed`;
        case "answer":
          return `<span class="update-content__title--pc">${this.nameLink}</span> answered the question`;
        default:
          return null;
      }
    },

    aboutText() {
      return this.extractAboutText(this.newsItem.full || "");
    },
  },

  methods: {
    extractAboutText(str) {
      const match = str.match(/<about>([\s\S]*?)<\/about>/);
      return match ? match?.at(1)?.trim() : "";
    },
  },
};
